import { render, staticRenderFns } from "./LoadingLayout.vue?vue&type=template&id=7b6b3c8a"
import script from "./LoadingLayout.vue?vue&type=script&lang=js"
export * from "./LoadingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6b3c8a')) {
      api.createRecord('7b6b3c8a', component.options)
    } else {
      api.reload('7b6b3c8a', component.options)
    }
    module.hot.accept("./LoadingLayout.vue?vue&type=template&id=7b6b3c8a", function () {
      api.rerender('7b6b3c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/LoadingLayout.vue"
export default component.exports